import React from 'react';
import PropTypes from 'prop-types';

export default function CloseIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148024' />
      <path
        fill={fill}
        d='M17.524 2.469a1.6 1.6 0 0 0-2.26 0L9.999 7.737 4.73 2.469a1.6 1.6 0 0 0-2.26 2.262l5.266 5.268-5.266 5.268a1.60124335 1.60124335 0 0 0 2.264 2.265l5.269-5.268 5.265 5.268a1.60124335 1.60124335 0 1 0 2.264-2.265l-5.265-5.268 5.265-5.268a1.6 1.6 0 0 0-.008-2.262Z'
        data-name='Caminho 21894'
      />
    </svg>
  );
}

CloseIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

CloseIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
